import React from "react";

/**
 * Thin top-of-viewport progress bar used as the Suspense fallback.
 * Unlike a fullscreen spinner, this does not visually replace the
 * previous page — the user keeps seeing the prior route until the
 * new chunk resolves.
 */
export default function RouteLoadingBar() {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Loading"
      className="fixed left-0 right-0 top-0 z-[9999] h-0.5 overflow-hidden bg-transparent pointer-events-none"
    >
      <div className="h-full w-1/3 bg-primary route-loading-bar-slide" />
      <style>{`
        @keyframes route-loading-bar-slide {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(150%); }
          100% { transform: translateX(400%); }
        }
        .route-loading-bar-slide {
          animation: route-loading-bar-slide 1.1s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}